import React from 'react';
import { FileTextIcon } from 'lucide-react';
export function C3TSeriesSection() {
  return <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-246">
      <div className="bg-[#002d4d] text-white py-6 px-8 flex flex-col md:flex-row md:items-center justify-between" data-id="element-247">
        <div data-id="element-248">
          <h2 className="text-3xl font-bold mb-1" data-id="element-249">Bodor C3T</h2>
          <h3 className="text-white/80 font-medium text-lg" data-id="element-250">
            Combination Plate/Tube Fiber Laser Cutting Machines
          </h3>
        </div>
      </div>

      <div className="p-8" data-id="element-251">
        <div className="grid md:grid-cols-12 gap-12 items-center mb-10" data-id="element-252">
          <div className="md:col-span-5 flex flex-col items-center bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-253">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/BODOR/2023/Plate%20Tube%20Combo%20Fiber%20Laser.png800x800.png" alt="Bodor C3T" className="block max-h-[350px] w-auto object-contain drop-shadow-xl mb-4" data-id="element-254" />
            <span className="bg-[#f5693d] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider text-center" data-id="element-255">
              Best performance, general use enclosed plate and tube laser
              cutting machine
            </span>
          </div>
          <div className="md:col-span-7" data-id="element-256">
            <ul className="space-y-4 text-gray-700" data-id="element-257">
              <li data-id="element-258">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-259">
                  Double Fast Exchange Tables
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-260">
                  Fast exchange of two tables greatly improves efficiency.
                  Chain-drive system has better rigidity and higher accuracy,
                  saving feeding time.
                </span>
              </li>
              <li data-id="element-261">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-262">
                  Tenon-and-mortise Welded Bed
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-263">
                  Use Tenon-and-mortise structure to provide stronger bearing
                  capacity. Solder joint fixing and structural bearing ensure
                  long-standing operation stability. Welded structure improves
                  shock absorption effect, lowering deviation caused by shock,
                  and offering more accurate cutting.
                </span>
              </li>
              <li data-id="element-264">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-265">
                  Double Automatic Centering Electric Chucks
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-266">
                  Double electric chucks with automatic centering function are
                  easy to operate and require little maintenance. Brand new
                  motor gives accurate control. Modular chuck components are
                  independently developed and can be quickly replaced.
                </span>
              </li>
              <li data-id="element-267">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-268">
                  Active Obstacle Avoidance
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-269">
                  Intelligent Anti-collision - 360° radar system can detect any
                  obstacles in advance and Z axis high-speed motion will be
                  activated to immediately avoid obstacles, avoiding collisions.
                  Higher Efficiency, Lower Cost - This function Lowers the
                  damage rate of laser head, and accordingly reduces maintenance
                  cost, prolonging service life of the machine.
                </span>
              </li>
              <li data-id="element-270">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-271">
                  All-around Protective Covering
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-272">
                  Full protection and encirclement | Isolation of laser
                  radiation pollution | Automatic soot collection | Ensure the
                  operation area is clean
                </span>
              </li>
              <li data-id="element-273">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-274">
                  Automatic focusing function of laser head
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-275">
                  By setting perforation focal length and cutting focal length
                  respectively, the cutting is more accurate. Suitable for
                  multiple focal lengths, and focal position will be
                  automatically adjusted based on thickness of different sheets.
                </span>
              </li>
              <li data-id="element-276">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-277">
                  Extruded Aluminum Beam
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-278">
                  Aviation-level material with enhanced rigidity, greatly
                  reduces beam deformation during high-speed operation, and
                  improves high-speed directional sensitivity and processing
                  efficiency.
                </span>
              </li>
              <li data-id="element-279">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-280">
                  BodorCloud - IoT Cloud Platform for Laser CNC Machines
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-281">
                  Apply for After-sale Service on Bodor Cloud Platform | Digital
                  Management of Equipment, Storage of Traceable Data | Real-time
                  Equipment Monitoring, Automatic Malfunction Alert | Access
                  through Multiple Devices, All-around Information Display
                </span>
              </li>
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 mt-8 pt-6 border-t border-gray-100" data-id="element-282">
              <span className="inline-flex items-center justify-center px-6 py-3 bg-[#002d4d] text-white font-bold uppercase text-sm rounded-md opacity-80 cursor-not-allowed" data-id="element-283">
                <span className="mr-2" data-id="element-284">+</span> Discover More
              </span>
              <span className="inline-flex items-center justify-center px-6 py-3 border-2 border-[#002d4d] text-[#002d4d] font-bold uppercase text-sm rounded-md opacity-80 cursor-not-allowed" data-id="element-285">
                <FileTextIcon className="w-4 h-4 mr-2" data-id="element-286" /> Download Brochure
              </span>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm" data-id="element-287">
          <table className="w-full text-sm text-left text-gray-600" data-id="element-288">
            <thead className="text-xs text-gray-700 uppercase bg-gray-100 border-b border-gray-200" data-id="element-289">
              <tr data-id="element-290">
                <th scope="col" className="px-6 py-4 font-bold border-r border-gray-200 w-1/2" data-id="element-291">
                  Model
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center w-1/2" data-id="element-292">
                  C3T
                </th>
              </tr>
            </thead>
            <tbody data-id="element-293">
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-294">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-295">
                  Working Area
                </th>
                <td className="px-6 py-4 text-center" data-id="element-296">3048mm*1524mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-297">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-298">
                  Laser Output Power
                </th>
                <td className="px-6 py-4 text-center" data-id="element-299">
                  6000w/3000w/2000w/1500w
                </td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-300">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-301">
                  Positioning accuracy
                </th>
                <td className="px-6 py-4 text-center" data-id="element-302">±0.05mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-303">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-304">
                  Repositioning accuracy
                </th>
                <td className="px-6 py-4 text-center" data-id="element-305">±0.03mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-306">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-307">
                  Max. linkage speed
                </th>
                <td className="px-6 py-4 text-center" data-id="element-308">100m/min</td>
              </tr>
              <tr className="bg-white hover:bg-gray-50" data-id="element-309">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-310">
                  Max. acceleration
                </th>
                <td className="px-6 py-4 text-center" data-id="element-311">1G</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}